import { auth } from "./Firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, UserCredential, onAuthStateChanged, User } from "firebase/auth";
import AdminAccount from "../../model/auth/AdminAccount";

/**
 * 이메일 / 비밀번호를 통한 Firebase Authentication 등록
 * @async
 * @function registerAdminAccountWithEmail
 * @param {AdminAccount} adminAccount - 관리자 계정 정보 (입력 form)
 * @param {string} password - 비밀번호
 * @returns {Promise<UserCredential>}
 * @throws {Error}
 */
// TODO: 전체적으로 변수 이름 관리 체계 필요
const registerAdminAccountWithEmail = async (adminAccount: AdminAccount, password: string): Promise<UserCredential> => {
    return await createUserWithEmailAndPassword(auth, adminAccount.email, password);
};

/**
 * 이메일 / 비밀번호를 통한 로그인
 * @async
 * @function loginWithEmail
 * @param {string} email - 사용자 이메일
 * @param {password} password - 비밀번호
 * @returns {Promise<UserCredential>}
 * @throws {Error}
 */
const loginWithEmail = async (email: string, password: string): Promise<UserCredential> => {
    return await signInWithEmailAndPassword(auth, email, password);
}

/**
 * Firebase User정보 조회 - 비동기 User정보 조회
 * @function getCurrentUser
 * @returns 
 */
const getCurrentUser = (): Promise<User> => {
    return new Promise((resolve, reject) => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            // 한 번만 실행되도록 정리
            unsubscribe();
            if (user) {
                resolve(user);
            } else {
                reject(new Error("AuthService::not-logged-in"));
            }
        })
    });
}

/**
 * 인증 토큰 갱신
 * @async
 * @function refreshIdToken
 * @returns {Promise<string>}
 * @throws {Error}
 */
const refreshIdToken = async (): Promise<string> => {
    // 새로고침시 일시적으로 auth.currentUser가 null이 되기 때문에 auth.currentUser 대신 onAuthStateChanged를 사용한다.
    const user = await getCurrentUser();

    try {
        return await user.getIdToken(true);
    } catch (e) {
        throw new Error("AuthService::refreshToken-failed");
    }
}

/**
 * 로그아웃
 * @async
 * @function signOut
 * @returns {Promise<void>}
 * @throws {Error}
 */
const signOut = async (): Promise<void> => {
    await auth.signOut();
}

export { registerAdminAccountWithEmail, loginWithEmail, refreshIdToken, signOut };